export const getCategoryFields = (category, flatFormFields) =>
  flatFormFields.filter((formField) =>
    formField.category.label.id.includes(category.id)
  );
